/* AB SPORT 2026-05-09: Daily collection product shuffle
   - Reshuffles products on collection pages daily so returning visitors see fresh layouts
   - Higher-inventory products weighted toward top ~60% of grid
   - Lower-inventory products mixed into bottom ~40%
   - Same seed per day = consistent within one visit, different tomorrow
   - Lightweight: no API calls, reads data-attributes from DOM
   - Runs after DOMContentLoaded, non-blocking
*/
(function(){
  'use strict';
  // Only run on collection pages
  if(!document.body.className.match(/template-collection/)) return;

  document.addEventListener('DOMContentLoaded', function(){
    var grid = document.querySelector('.product-collection.products-grid, .products-grid');
    if(!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.grid-item, .col-xs-3'));
    if(items.length < 4) return; // not enough to shuffle

    // Day-based seed: changes daily
    var now = new Date();
    var seed = now.getFullYear() * 10000 + (now.getMonth()+1) * 100 + now.getDate();

    // Simple seeded PRNG (mulberry32)
    function mulberry32(a) {
      return function() {
        a |= 0; a = a + 0x6D2B79F5 | 0;
        var t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
      };
    }
    var rng = mulberry32(seed);

    // Fisher-Yates shuffle with seeded RNG
    function shuffle(arr) {
      var a = arr.slice();
      for(var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(rng() * (i + 1));
        var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
      }
      return a;
    }

    // Try to get inventory count from product data on page
    // Ella theme stores variant data in script tags; we estimate from the card
    // For simplicity, split into "in stock" vs "low stock" by checking sold-out badge
    var highStock = [];
    var lowStock = [];

    items.forEach(function(item) {
      var soldOutBadge = item.querySelector('.soldout, .sold-out, .badge-soldout');
      if(soldOutBadge && getComputedStyle(soldOutBadge).display !== 'none') {
        // Skip completely sold out items
        return;
      }
      // Check if product has a sale badge (lower priority in shuffle)
      var saleBadge = item.querySelector('.sale, .badge-sale, .on-sale');
      if(saleBadge) {
        lowStock.push(item);
      } else {
        highStock.push(item);
      }
    });

    // Shuffle each group
    var shuffledHigh = shuffle(highStock);
    var shuffledLow = shuffle(lowStock);

    // Determine split: top 60% from high stock, rest from low
    var totalSlots = shuffledHigh.length + shuffledLow.length;
    var topSlots = Math.ceil(totalSlots * 0.6);

    // Build final order: high stock first (shuffled), then mix in low stock
    var finalOrder = [];
    var hiIdx = 0, loIdx = 0;

    for(var i = 0; i < totalSlots; i++) {
      if(i < topSlots && hiIdx < shuffledHigh.length) {
        finalOrder.push(shuffledHigh[hiIdx++]);
      } else if(loIdx < shuffledLow.length) {
        finalOrder.push(shuffledLow[loIdx++]);
      } else if(hiIdx < shuffledHigh.length) {
        finalOrder.push(shuffledHigh[hiIdx++]);
      }
    }

    // Mix a few low-stock items into the top section for variety (every 4th slot)
    if(shuffledLow.length > 0 && finalOrder.length > 8) {
      for(var i = 3; i < Math.min(topSlots, finalOrder.length); i += 4) {
        if(loIdx < shuffledLow.length) {
          // Find a low-stock item not already placed
          var swapItem = null;
          for(var k = topSlots; k < finalOrder.length; k++) {
            if(lowStock.indexOf(finalOrder[k]) !== -1) {
              swapItem = k; break;
            }
          }
          if(swapItem !== null) {
            var tmp = finalOrder[i];
            finalOrder[i] = finalOrder[swapItem];
            finalOrder[swapItem] = tmp;
          }
        }
      }
    }

    // Re-append in new order (DOM reflow happens once)
    var fragment = document.createDocumentFragment();
    finalOrder.forEach(function(item) {
      fragment.appendChild(item);
    });
    // Append any items we skipped (sold out) at the very end
    items.forEach(function(item) {
      if(finalOrder.indexOf(item) === -1) {
        fragment.appendChild(item);
      }
    });
    grid.appendChild(fragment);
  });
})();
